import { search, post, get, put, remove } from '../../helpers/api';

export const COUNCIL_DECISION_SERVICE_URI = '/taxonomies';
export const COUNCIL_DECISION_BASE_URI = '/api/v1/council-decision-report';

export const searchCouncilDecisionsReports = async (data) =>
  search(
    `${COUNCIL_DECISION_SERVICE_URI}${COUNCIL_DECISION_BASE_URI}/search`,
    data,
  );

export const getCouncilDecisionReportById = async (id) =>
  get(`${COUNCIL_DECISION_SERVICE_URI}${COUNCIL_DECISION_BASE_URI}/${id}`);

export const createCouncilDecisionReport = async (councilDecisionReport) =>
  post(
    `${COUNCIL_DECISION_SERVICE_URI}${COUNCIL_DECISION_BASE_URI}`,
    councilDecisionReport,
  );

export const updateCouncilDecisionReport = async (councilDecisionReport) =>
  put(
    `${COUNCIL_DECISION_SERVICE_URI}${COUNCIL_DECISION_BASE_URI}/${councilDecisionReport.id}`,
    councilDecisionReport,
  );

export const deleteCouncilDecisionReport = async (councilDecisionReport) =>
  remove(
    `${COUNCIL_DECISION_SERVICE_URI}${COUNCIL_DECISION_BASE_URI}/${councilDecisionReport.id}`,
  );
